import axios from "axios";
import {handleAxiosError} from "./servicesUtils";
import {PLACE_TYPE} from "../Types/PlaceType";
import Place from "@wikicasa/common/model/Place"
//@ts-ignore
import {appendQueryString} from "@utils/UrlBuilderUtils";

//@ts-ignore
const baseURL = window["_baseURLIt"]
const baseController = "/ws"


export const getPlacesByQuery = async (value: string, placeType: PLACE_TYPE[] = [], provinceId: (number | string | null) = ""): Promise<Place[]> => {
    try {
        if (!provinceId)
            provinceId = "";

        const res = await axios.get(`${baseController}/places?query=${value}&type=${placeType.join(",")}${provinceId ? `&provinceID=${provinceId}` : ""}`);
        return res.data as Place[];
    } catch (err) {
        handleAxiosError(err)
        throw err;
    }
}

export function getPlace(query: string, types = "C,P,Z,L,I,R,A"): Promise<Array<Place>> {
    return new Promise(resolve => {
        axios.get(`${baseController}/places?query=${query}&type=${types}`).then(response => {
            if (!response?.data) {
                resolve([]);
            }
            resolve(response?.data);
        });
    });
}

export function getZones(cityID: number): Promise<Array<Place>> {
    return new Promise(resolve => {
        axios.get(`${baseController}/zones?cityID=${cityID}`).then(response => {
            if (!response?.data) {
                resolve([]);
                return;
            }
            resolve(response?.data);
        });
    });
}

export const getDistrictsByZoneId = async (zoneID: number): Promise<Place[]> => {
    try {

        const res = await axios.get(
            appendQueryString(
                new URL(`${baseURL}${baseController}/districts`),
                {zoneID})
                .toString()
        )
        return res.data as Place[]
    } catch (e) {
        handleAxiosError(e)
        throw e
    }
}